import { useState, useEffect } from "react";
import {
  HtmlEditor,
  Image,
  Inject,
  Link,
  QuickToolbar,
  RichTextEditorComponent,
  Toolbar,
  Table,
} from "@syncfusion/ej2-react-richtexteditor";
import { useParams } from "react-router-dom";
import { Link as LinkPage } from "react-router-dom";
import Header from "../clubDashboard/Header/Header";
import combinedServices from "../../shared/services/user-service"; // Must include all CRUD
import Swal from "sweetalert2";

function CanonsOfConductEditor() {
  const { districtId } = useParams();
  const [editorContent, setEditorContent] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [existingCanonId, setExistingCanonId] = useState(null);

  useEffect(() => {
    fetchCanonsOfConduct();
  }, [districtId]);

  const fetchCanonsOfConduct = async () => {
    try {
      const response = await combinedServices.getCanonsOfConductByDistrictId(
        districtId
      );
      if (response && response.data.canons_of_conduct) {
        setEditorContent(response.data.canons_of_conduct);
        setExistingCanonId(response.data.id);
      }
    } catch (error) {
      console.error("Failed to fetch canons:", error);
    }
  };

  const toolbarSettings = {
    items: [
      "Bold",
      "Italic",
      "Underline",
      "StrikeThrough",
      "FontName",
      "FontSize",
      "FontColor",
      "BackgroundColor",
      "LowerCase",
      "UpperCase",
      "|",
      "Formats",
      "Alignments",
      "OrderedList",
      "UnorderedList",
      "Outdent",
      "Indent",
      "|",
      "CreateLink",
      "Image",
      "|",
      "ClearFormat",
      "Print",
      "SourceCode",
      "FullScreen",
      "|",
      "Undo",
      "Redo",
    ],
  };

  const quickToolbarSettings = {
    image: [
      "Replace",
      "Align",
      "Caption",
      "Remove",
      "InsertLink",
      "OpenImageLink",
      "-",
      "EditImageLink",
      "RemoveImageLink",
      "Display",
      "AltText",
      "Dimension",
    ],
    link: ["Open", "Edit", "UnLink"],
  };

  const insertImageSettings = {
    saveUrl:
      "https://services.syncfusion.com/js/production/api/FileUploader/Save",
    removeUrl:
      "https://services.syncfusion.com/js/production/api/FileUploader/Remove",
    height: 165,
    width: 165,
  };

  const saveContent = (e) => {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = e.value;

    const images = tempElement.querySelectorAll("img");
    images.forEach((img) => {
      if (img.src.startsWith("blob:")) {
        img.src = imageUrl;
      }
    });

    const modifiedContent = tempElement.innerHTML;
    setEditorContent(modifiedContent);
  };

  const imageUploadHandler = async (args) => {
    try {
      const file = args.file.rawFile;
      const formData = new FormData();
      formData.append("image", file);

      const response = await combinedServices.uploadImage(formData);
      const uploadedImageUrl = response.data.location;

      setImageUrl(uploadedImageUrl);
    } catch (error) {
      console.error("Image upload failed:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!editorContent.trim()) {
      return Swal.fire({
        icon: "warning",
        title: "Empty Content",
        text: "Please enter some content.",
      });
    }

    setIsSubmitting(true);

    try {
      if (existingCanonId) {
        // Update
        await combinedServices.updateCanonsOfConduct({
          id: existingCanonId,
          canons_of_conduct: editorContent,
        });
        Swal.fire("Updated!", "Canons of conduct updated.", "success");
      } else {
        // Create
        await combinedServices.createCanonsOfConduct({
          district_id: districtId,
          canons_of_conduct: editorContent,
        });
        Swal.fire("Created!", "Canons of conduct created.", "success");
      }
    } catch (error) {
      Swal.fire("Error", "Something went wrong. Try again.", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDelete = async () => {
    if (!existingCanonId) return;

    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This will permanently delete the canons of conduct.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });

    if (confirm.isConfirmed) {
      try {
        await combinedServices.deleteCanonsOfConduct(existingCanonId);
        Swal.fire("Deleted!", "Canons of conduct has been deleted.", "success");
        setEditorContent("");
        setExistingCanonId(null);
      } catch (error) {
        Swal.fire("Error", "Failed to delete content.", "error");
      }
    }
  };

  return (
    <div
      style={{
        backgroundColor: "#ebedf5",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Header />

      <div className="email-form-container dbRight">
        <div className="container flexBox">
          <div style={{ color: "black" }}>
            <div className="innerHd" style={{ color: "black" }}>
              Canons of Conduct
            </div>
            <div className="bradcrumb">
              <LinkPage to="/club-dashboard" style={{ color: "gray" }}>
                Home
              </LinkPage>
              <LinkPage to="" style={{ color: "black" }}>
                Canons of conduct
              </LinkPage>
            </div>
          </div>
        </div>

        <div
          className="email-form-card"
          style={{ width: "120%", margin: "20px auto" }}
        >
          <h2>Canons of Conduct</h2>
          <form onSubmit={handleSubmit}>
            <RichTextEditorComponent
              height={400}
              toolbarSettings={toolbarSettings}
              quickToolbarSettings={quickToolbarSettings}
              insertImageSettings={insertImageSettings}
              value={editorContent}
              change={saveContent}
              imageUploadSuccess={imageUploadHandler}
            >
              <Inject
                services={[
                  Toolbar,
                  Image,
                  Link,
                  HtmlEditor,
                  QuickToolbar,
                  Table,
                ]}
              />
            </RichTextEditorComponent>

            <div style={{ marginTop: "1rem", display: "flex", gap: "1rem" }}>
              <button
                type="submit"
                disabled={isSubmitting}
                style={{
                  padding: "10px 20px",
                  backgroundColor: isSubmitting ? "#999" : "#007bff",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: isSubmitting ? "not-allowed" : "pointer",
                }}
              >
                {isSubmitting
                  ? "Saving..."
                  : existingCanonId
                  ? "Update"
                  : "Create"}
              </button>

              {existingCanonId && (
                <button
                  type="button"
                  onClick={handleDelete}
                  style={{
                    padding: "10px 20px",
                    backgroundColor: "#dc3545",
                    color: "#fff",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                >
                  Delete
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CanonsOfConductEditor;
